export const BANK_NOC = {
    VALID_NOC: "VALID_NOC",
    NO_VALID_NOC: "NO_VALID_NOC"
};

export const BANK_NOC_OPTIONS = [
    {
        type: BANK_NOC.VALID_NOC,
        label: "Yes, I have vaild NOC"
    },
    {
        type: BANK_NOC.NO_VALID_NOC,
        label: "No, I don’t have valid NOC"
    }
];

export const LOAN_STATUS = {
    OPEN: "OPEN",
    CLOSED: "CLOSED",
    PENDING: "PENDING"
};
